'use client'

import { useGetProjectId } from '@/app/slugs'
import { apiResponseHandler, queryKeys } from '@/shared/api/react-query'
import { GetProjectFoundersReportParams } from '@/shared/api/end-points/project'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { FoundersReportResponse } from '../../lib'
import services from '../services'

const useGetFoundersReport = (partialParams?: GetProjectFoundersReportParams) => {
  const projectIdParams = useGetProjectId()
  const params = partialParams || projectIdParams

  const queryKey = [queryKeys((a, m) => a.project.getProjectFoundersReport(params) + m.get)]

  const query = useQuery({
    queryKey,
    queryFn: async () => apiResponseHandler(await services.getFoundersReport(params)),
    enabled: !!params.projectId,
    refetchOnWindowFocus: false,
  })

  return {
    ...query,
    queryKey,
  } as UseQueryResult<FoundersReportResponse> & { queryKey: typeof queryKey }
}

export default useGetFoundersReport
